export class MethodSearchRequest {
    constructor(public nameFilter?: any) {
    }
}
